import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { createOrder, getOrderDetails } from "../Redux/Actions/OrderActions";
import { ORDER_CREATE_RESET } from "../Redux/Constants/OrderConstants";
import Header from "./../components/Header";
import Message from "./../components/LoadingError/Error";
import {
  DEFAULT_CURRENCY,
  DEFAULT_SHIPPING_CHARGE,
  IMAGE_CACHE_URL,
} from "../Redux/Constants/GlobalConstant";
import MobileNav from "../components/MobileNav";
import Loading from "../components/LoadingError/Loading";
import BestDealSection from "../components/homeComponents/BestDealSection";
import { DEFAULT_PLACE_ORDER_SCREEN_COUPON } from "../config/Constant";

const PlaceOrderScreen = ({ history }) => {
  // window.scrollTo(0, 0);

  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  /* ---------------- Coupon State ---------------- */
  const [showCouponInput, setShowCouponInput] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [fastDelivery, setFastDelivery] = useState(false);
  const [couponAmount, setCouponAmount] = useState(0.0);

  const handleCouponCode = () => {
    if (couponCode.length !== 6) {
      alert("Coupon code must be 6 capital letters");
      return;
    }

    if (couponCode === DEFAULT_PLACE_ORDER_SCREEN_COUPON || 1) {
      setCouponApplied(true);
      let totalPrice = (Number(cart.totalPrice) * 0.1).toFixed(2);
      setCouponAmount(totalPrice);
      cart.totalPrice = parseFloat(
        Number(cart.totalPrice) - Number(totalPrice),
      ).toFixed(2);

      alert("Coupon applied successfully");
    }
  };

  // Calculate Price
  const addDecimals = (num) => {
    return (Math.round(num * 100) / 100).toFixed(2);
  };

  cart.itemsPrice = addDecimals(
    cart.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0),
  );
  cart.itemsMrpPrice = addDecimals(
    cart.cartItems.reduce((acc, item) => acc + item.mrp_price * item.qty, 0),
  );
  cart.shippingPrice = addDecimals(
    cart.itemsPrice > 100 ? 0.0 : DEFAULT_SHIPPING_CHARGE,
  );
  cart.taxPrice = addDecimals(Number((0.0 * cart.itemsPrice).toFixed(2)));
  cart.tti_credits =
    addDecimals(Number((0.05 * cart.itemsPrice).toFixed(2))) * 100;

  cart.totalPrice = (
    Number(cart.itemsPrice) +
    // Number(cart.shippingPrice) +
    Number(cart.taxPrice)
  ).toFixed(2);

  const orderCreate = useSelector((state) => state.orderCreate);
  const { order, success, loading, error } = orderCreate;
  if (localStorage.getItem("paymentMethod")) {
    cart.paymentMethod = localStorage.getItem("paymentMethod");
  }
  useEffect(() => {
    // console.log(cart);
    if (success) {
      history.push(`/order/${order._id}`);
      dispatch({ type: ORDER_CREATE_RESET });
      dispatch(getOrderDetails(order._id));
    }
  }, [history, dispatch, success, order, cart]);

  useEffect(() => {
    // console.log(cart);
    if (error) {
      // Reload page
      setTimeout(() => {
        window.location.reload(); // reload after 2 sec
        // Or redirect instead:
        // navigate("/");
      }, 2000);
    }
  }, [error, cart]);

  const placeOrderHandler = () => {
    let userReply = false;
    if (cart.totalPrice < 20) {
      userReply = window.confirm(
        "Your order is under £20, so £" +
          cart.shippingPrice +
          " shipping charges will apply. Continue?",
      );
      console.log(userReply);
    }
    // console.log(cart);
    dispatch(
      createOrder({
        orderItems: cart.cartItems,
        shippingAddress: cart.shippingAddress,
        paymentMethod: cart.paymentMethod,
        itemsPrice: cart.itemsPrice,
        shippingPrice: cart.shippingPrice,
        taxPrice: cart.taxPrice,
        totalPrice: cart.totalPrice,
        isCOD: cart?.paymentMethod === "cod" ? true : false,
        couponDetail: couponCode,
        couponDiscount: couponAmount,
        userNotes: cart.userNotes,
        fastDelivery: cart.fastDelivery,
      }),
    );
  };

  const statushandler = () => {
    // console.log("Delivery status: ", fastDelivery);
    cart.fastDelivery = fastDelivery ? false : true;
    setFastDelivery(fastDelivery ? false : true);
    if (fastDelivery ? false : true) {
      alert(
        "Fast delivery selected 🚀 A small extra fee may apply for priority service",
      );
    }
  };

  return (
    <>
      <Header />
      <MobileNav />
      {loading ? (
        <Loading />
      ) : error ? (
        <Message variant="alert-danger">{error}</Message>
      ) : (
        <>
          <div className="container">
            <div className="row  order-detail desktop-cart-view">
              <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
                <div className="row ">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-user"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Customer</strong>
                    </h5>
                    <p>{userInfo?.name}</p>
                    <p>{userInfo?.email}</p>
                  </div>
                </div>
              </div>
              {/* 2 */}
              <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
                <div className="row">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-truck-moving"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Order Info</strong>
                    </h5>
                    <p>
                      Shipping:<strong> {cart?.shippingAddress.city} </strong>
                    </p>
                    <p>
                      Pay method:
                      <strong> {cart?.paymentMethod?.toUpperCase()} </strong>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
                <div className="row">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Deliver To</strong>
                    </h5>
                    <p>
                      {cart?.shippingAddress.city},{" "}
                      {cart?.shippingAddress.address},{" "}
                      {cart?.shippingAddress.postalCode}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row order-products justify-content-between">
              <div className="col-lg-8">
                {cart.cartItems.length === 0 ? (
                  <Message variant="alert-info mt-5">
                    Your cart is empty
                  </Message>
                ) : (
                  <>
                    {cart.cartItems.map((item, index) => (
                      <div key={index}>
                        <div className="order-product row desktop-cart-view ">
                          <div className="col-md-3 col-6">
                            <img
                              src={IMAGE_CACHE_URL + item.image}
                              alt={item.name}
                            />
                          </div>
                          <div className="col-md-5 col-6 d-flex align-items-center">
                            <Link to={`/products/${item.product}`}>
                              <h6>{item.name}</h6>
                            </Link>
                          </div>
                          <div className="mt-3 mt-md-0 col-md-2 col-6  d-flex align-items-center flex-column justify-content-center ">
                            <h4>QTY</h4>
                            <h6>{item.qty}</h6>
                          </div>
                          <div className="mt-3 mt-md-0 col-md-2 col-6 align-items-end  d-flex flex-column justify-content-center ">
                            <h4>SUBTOTAL</h4>
                            <h6>
                              {item.mrp_price > item.price && (
                                <span className="text-overline">
                                  {DEFAULT_CURRENCY}
                                  {(item.mrp_price * item.qty).toFixed(2)}
                                  <br></br>
                                </span>
                              )}
                              {DEFAULT_CURRENCY}
                              {(item.price * item.qty).toFixed(2)}
                            </h6>
                          </div>
                        </div>
                        {/* Mobile View Here */}
                        <div
                          className="order-product cart-item row mobile-cart-view "
                          key={index}
                        >
                          <div className="cart-image-name-together">
                            <img
                              src={IMAGE_CACHE_URL + item.image}
                              alt={item.name}
                            />
                            <Link to={`/products/${item.product}`}>
                              <h4>{item.name}</h4>
                            </Link>
                          </div>
                          <div className="cart-price cart-price-total">
                            <h4>QTY</h4>
                            <h6 className="po-item-qty">{item.qty}</h6>
                          </div>
                          <div className="cart-price cart-price-total">
                            <h4>SUBTOTAL</h4>
                            <h6 className="po-item-qty">
                              {item.mrp_price !== item.price && (
                                <span className="text-overline">
                                  {DEFAULT_CURRENCY}
                                  {(item.qty * item.mrp_price).toFixed(2)}
                                  <br></br>
                                </span>
                              )}
                              {DEFAULT_CURRENCY}{" "}
                              {(item.qty * item.price).toFixed(2)}
                            </h6>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="col-lg-6">
                      <div className="form-label">
                        <strong>Order Notes</strong>(Optional)
                        <textarea
                          className="form-control"
                          rows="2"
                          placeholder="Add any special instructions or notes for your order..."
                          onChange={(e) => (cart.userNotes = e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="col-lg-3 d-flex align-items-end flex-column mt-5 subtotal-order">
                {error && (
                  <div className="col-12">
                    <Message variant="alert-danger">{error}</Message>
                  </div>
                )}
                <table className="table table-bordered">
                  <tbody>
                    {cart.itemsMrpPrice !== cart.itemsPrice && (
                      <tr>
                        <td>
                          <strong>Total MRP</strong>
                        </td>
                        <td className="text-align-right">
                          {DEFAULT_CURRENCY}{" "}
                          {parseFloat(cart.itemsMrpPrice).toFixed(2)}
                        </td>
                      </tr>
                    )}
                    {cart.itemsMrpPrice !== cart.itemsPrice && (
                      <tr>
                        <td>
                          <strong>Total Saving</strong>
                        </td>
                        <td className="text-align-right">
                          {DEFAULT_CURRENCY}{" "}
                          {(cart.itemsMrpPrice - cart.itemsPrice).toFixed(2)}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        <strong>Our Price</strong>
                      </td>
                      <td className="text-align-right">
                        {DEFAULT_CURRENCY}{" "}
                        {parseFloat(cart.itemsPrice).toFixed(2)}
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={2}>
                        {!showCouponInput ? (
                          <span
                            style={{ cursor: "pointer", color: "#007bff" }}
                            onClick={() => setShowCouponInput(true)}
                          >
                            Have Coupon Code
                          </span>
                        ) : (
                          <div className="d-flex gap-2">
                            <input
                              type="text"
                              maxLength={6}
                              value={couponCode}
                              onChange={(e) =>
                                setCouponCode(e.target.value.toUpperCase())
                              }
                              className="form-control"
                              placeholder="COUPON"
                            />
                            <button
                              className="btn btn-sm btn-success"
                              onClick={handleCouponCode}
                              disabled={couponApplied}
                            >
                              Apply
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                    {couponAmount > 0 && (
                      <tr>
                        <td>
                          <strong>Discount</strong>
                        </td>
                        <td className="text-align-right">
                          {DEFAULT_CURRENCY}{" "}
                          <b>{parseFloat(couponAmount).toFixed(2)}</b>
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td className="text-align-right">
                        {DEFAULT_CURRENCY}{" "}
                        <b>
                          {parseFloat(cart.totalPrice - couponAmount).toFixed(
                            2,
                          )}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Fast Delivery</strong>
                      </td>
                      <td className="text-align-right">
                        <span
                          onClick={() => statushandler()}
                          className={
                            fastDelivery
                              ? "btn btn-sm btn-outline-success "
                              : "btn btn-sm btn-outline-danger"
                          }
                        >
                          <i
                            className={
                              fastDelivery
                                ? "fas fa-toggle-on"
                                : "fas fa-toggle-off"
                            }
                          ></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                {cart.cartItems.length === 0 ? null : (
                  <button type="submit" onClick={placeOrderHandler}>
                    PLACE ORDER
                  </button>
                )}

                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <td className="text-align-left">
                        <strong>Reward Cash Points*</strong>
                      </td>
                      <td className="text-align-right">
                        {/* {DEFAULT_CURRENCY}  */}
                        {parseInt(cart.tti_credits)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row  order-detail mobile-cart-view-2">
              <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
                <div className="row ">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-user"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Customer</strong>
                    </h5>
                    <p>{userInfo.name}</p>
                    <p>{userInfo.email}</p>
                  </div>
                </div>
              </div>
              {/* 2 */}
              <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
                <div className="row">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-truck-moving"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Order Info</strong>
                    </h5>
                    <p>
                      Shipping:<strong> {cart.shippingAddress.city}</strong>
                    </p>
                    <p>
                      Pay method:
                      <strong> {cart.paymentMethod?.toUpperCase()}</strong>
                    </p>
                  </div>
                </div>
              </div>
              {/* 3 */}
              <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
                <div className="row">
                  <div className="col-md-4 center">
                    <div className="alert-success order-box">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                  </div>
                  <div className="col-md-8 center">
                    <h5>
                      <strong>Deliver To</strong>
                    </h5>
                    <p>
                      Address: {cart.shippingAddress.city},{" "}
                      {cart.shippingAddress.address},{" "}
                      {cart.shippingAddress.postalCode}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <BestDealSection />
          </div>
        </>
      )}
    </>
  );
};

export default PlaceOrderScreen;
